// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax } from 'components/styles/_media'
import Colors from 'components/styles/colors'
import SearchProgressModal from 'components/organisms/SearchProgressModal'
import RoomList from 'components/organisms/room/RoomList'
import RoomListHeader from 'components/organisms/RoomListHeader'
import SearchForm, {
  type PropTypes as SearchFormTypes,
} from 'containers/organisms/SearchForm'
import ListPager, {
  type PropTypes as PagerType,
} from 'containers/organisms/ListPager'

const SideBar = styled.div`
  position: relative;
  float: left;
  width: 288px;
  padding: 0 28px 0 12px;
  ${mediaMax.desktop`
    position: fixed;
    width: 100%;
    height: 100vh;
    padding: 20px 12px;
    overflow-y: scroll;
    z-index: 100;
    top: 0;
    background-color: ${Colors.white};
  `};
`
const Main = styled.div`
  float: right;
  width: 100%;
  margin-left: -288px;
  padding-left: 288px;
  ${mediaMax.desktop`
    margin-left: 0;
    padding-left: 0;
  `};
`
const Inner = styled.div`
  padding: 0 12px;
`
const AllContainer = styled.div`
  width: 80%;
  max-width: 1100px;
  margin: auto;
  position: relative;
  padding: 44px 0;
  ${mediaMax.desktop`
    padding: 20px 0;
  `};
`
export type PropTypes = {
  roomCardPropsList: Array<RoomCardTypes>,
  totalCount: string,
  onClickViewType?: Function,
  mapViewLink?: string,
  showSearchForm: boolean,
  isLoading?: boolean,
  sponsoredPromotions: Array<Object>,
  onClickFavorite: Function,
  viewer: Object,
}

export default (props: PropTypes) => (
  <AllContainer className="clearfix">
    {props.showSearchForm && (
      <SideBar>
        <SearchForm
          onSubmit={props.searchFormOnSubmit}
          amenities={props.amenities}
          eventTypes={props.eventTypes}
          capacities={props.capacities}
          searchSessionId={props.searchSessionId}
          sponsoredPromotions={props.sponsoredPromotions}
        />
      </SideBar>
    )}
    <Main>
      <Inner>
        {props.isLoading && <SearchProgressModal />}
        <div>
          <RoomListHeader
            totalCount={props.totalCount}
            mapViewLink={props.mapViewLink}
            onClickViewType={props.onClickViewType}
          />
          <RoomList
            totalCount={props.totalCount}
            rooms={props.roomCardPropsList}
            onClickFavorite={props.onClickFavorite}
          />
          <ListPager
            totalCount={props.totalCount}
            searchSessionId={props.searchSessionId}
            pageInfo={props.pageInfo}
            perPage={props.perPage}
          />
        </div>
      </Inner>
    </Main>
  </AllContainer>
)



// WEBPACK FOOTER //
// ./src/components/pages/SearchPage/List.jsx